(function () {
  function initHeader(root) {
    if (!root || root.dataset.ampHeaderReady === 'true') return;
    root.dataset.ampHeaderReady = 'true';

    var toggle = root.querySelector('[data-amp-menu-toggle]');
    var menu = root.querySelector('[data-amp-menu]');
    if (!toggle || !menu) return;

    function setOpen(open) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      root.classList.toggle('is-menu-open', open);
      document.documentElement.classList.toggle('amp-menu-open', open);
    }

    toggle.addEventListener('click', function () {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });

    menu.addEventListener('click', function (event) {
      if (event.target.closest('a')) setOpen(false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') setOpen(false);
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth >= 990) setOpen(false);
    });
  }

  function boot() {
    document.querySelectorAll('[data-amp-site-header]').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
